import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgParkingSpot(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M9.92499 6.92487V12.078L12.4567 12.0776C13.913 12.0776 15.075 10.9138 15.075 9.50104C15.075 8.08835 13.9132 6.92453 12.457 6.92447L9.92499 6.92487Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 2H4C2.89545 2 2 2.89542 2 4V20C2 21.1046 2.89545 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89542 21.1046 2 20 2ZM8.99988 5.07501L12.4567 5.07446C14.9141 5.07446 16.925 7.04605 16.925 9.50104C16.925 11.956 14.9143 13.9276 12.457 13.9276L9.92499 13.928V18.0005C9.92499 18.5114 9.51086 18.9256 9 18.9256C8.48914 18.9256 8.07501 18.5114 8.07501 18.0005V6.00015C8.07501 5.48927 8.48913 5.07501 8.99988 5.07501Z", fill: "currentColor" })));
}
export default SvgParkingSpot;
